module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW TO")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ET THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OST")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT OF")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "logo3",
      "src": "images/ld.jpg"
    }
  }), _c('i', [_vm._v("Part One")]), _c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "logo2",
      "src": "images/rd.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "partit"
  }, [_c('a', {
    attrs: {
      "href": "#/p1"
    }
  }, [_vm._v("LIVING DEEP IN THE KINGDOM")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_vm._v("1  T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URRENDER")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Soul Training Exercise: The Servant of the Lord")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2  G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROWING IN")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACE AND")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOWLEDGE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Soul Training Exercise: In My Father’s House")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3  L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVING FROM")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOVE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Soul Training Exercise: Set Your Mind on Christ")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTENING TO")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Soul Training Exercise: Speak, Lord")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "logo4",
      "src": "images/ld.jpg"
    }
  }), _c('i', [_vm._v("Part Two")]), _c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "logo5",
      "src": "images/rd.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "partit"
  }, [_c('span', {
    attrs: {
      "href": "#/p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEVELOPING KINGDOM VIRTUES")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5  R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAXING INTO")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Soul Training Exercise: Let It Be Done for Me")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6  E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBRACING")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Soul Training Exercise: My Eyes Have Seen Your Salvation")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URPRISED BY")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Soul Training Exercise: Go and Bear Fruit")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8  D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISCOVERING A")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEPER")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OY")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Soul Training Exercise: Blessed Are You")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TUDY")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UIDE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPRENTICE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NSTITUTE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAISE FOR")]), _vm._v(" "), _c('i', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGNIFICENT")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURNEY")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITLES FROM")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTER")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARSITY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0